import type { ReactNode } from 'react';
import {
  isEfaxIdentifying,
  type AnonymousRecordUploadStatus,
} from '../../types';

export const IdentifyingPlaceholder = () => (
  <span className="text-muted-foreground italic">Identifying...</span>
);

interface IdentifyingCellProps {
  status: AnonymousRecordUploadStatus;
  children: ReactNode;
}

export const IdentifyingCell = ({ status, children }: IdentifyingCellProps) =>
  isEfaxIdentifying(status) ? <IdentifyingPlaceholder /> : children;
